import initQiankun from "./initQiankun";
export default { initQiankun };
